<template>
    <div>
        <LazySudosuFrame v-if="isImpersonated" />
        <CountryLaunchingBanner />
        <UnsubscribeInvitationBanner />
        <HeaderUnlogged v-if="showNewUnloggedNavbar" />
        <NavbarUnlogged v-else :prismic-document="navbar!" theme="strategy" />
        <slot />
        <!-- Event when logged in, we want to display this footer -->
        <FooterUnlogged :prismic-document="footer!" :always-visible="true" />

        <ClientOnly>
            <LazyHostRedirectionDialog v-if="!loggedIn" />
        </ClientOnly>
    </div>
</template>

<script setup lang="ts">
    import {ref} from 'vue';
    import type {PrismicDocument} from '@prismicio/types';
    import {storeToRefs} from 'pinia';
    import {FooterUnlogged, LazyHostRedirectionDialog, HeaderUnlogged, LazySudosuFrame, NavbarUnlogged} from '#components';
    import {useAsyncData, useAuth, useNewUnloggedNavbar} from '#imports';
    import CountryLaunchingBanner from '~/components/CountryLaunchingBanner.vue';
    import UnsubscribeInvitationBanner from '~/components/UnsubscribeInvitationBanner.vue';
    import {usePrismicDocument} from '~/composables/content/usePrismicDocument';

    const navbar = ref<PrismicDocument | undefined | null>();
    const footer = ref<PrismicDocument | undefined | null>();

    const {fetchDocument: fetchHeader} = usePrismicDocument('maltStrategyHeader');
    const {fetchDocument: fetchFooter} = usePrismicDocument('maltStrategyFooter');

    const showNewUnloggedNavbar = useNewUnloggedNavbar();
    const auth = useAuth();
    const {loggedIn, isImpersonated} = storeToRefs(auth);

    const {data: navbarData} = await useAsyncData('maltStrategyHeader', () => fetchHeader(), {deep: true});
    const {data: footerData} = await useAsyncData('maltStrategyFooter', () => fetchFooter(), {deep: true});
    navbar.value = navbarData.value;
    footer.value = footerData.value;
</script>
